import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface AlertProps{
  header: string;
  primaryButtonText: string;
  secondaryButtonText: string;
  message: string;
}

@Component({
  selector: 'app-alert-confirmation',
  standalone: false,
  templateUrl: './alert-confirmation.component.html',
  styleUrl: './alert-confirmation.component.scss'
})
export class AlertConfirmationComponent {

  header!:string; 
  message!:string; 
  primaryButtonText:string = 'Confirm'; 
  secondaryButtonText:string = 'Cancel';

  constructor(
    public dialogRef: MatDialogRef<AlertConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data:AlertProps,
  ) { }

  ngOnInit(): void {
    this.header = this.data.header ?? 'Alert';
    this.primaryButtonText = this.data.primaryButtonText ?? 'Confirm';
    this.secondaryButtonText = this.data.secondaryButtonText ?? 'Cancel';
    this.message = this.data.message;
  }
  
  closeDialog() {
    this.dialogRef.close('CLOSE');
  }

  closeDialogWithResult() {
    this.dialogRef.close('CONFIRM');
  }

}
